import type * as React from "react";
import { Box } from "../../components/ui/box";
import type { Omittable } from "../../lib/props";

export type EntitySelectorFooterProps = Omittable<{
  children: React.ReactNode;
  ref?: React.Ref<HTMLDivElement>;
}>;

function EntitySelectorFooter({ children, ref }: EntitySelectorFooterProps) {
  return (
    <Box ref={ref} border="top" padding="xs" shrink={false}>
      {children}
    </Box>
  );
}

EntitySelectorFooter.displayName = "EntitySelectorFooter";

export { EntitySelectorFooter };
